// Default Messy Pups B2B flyer content (host-site pitch).
export const BRAND = {
  forest: "#114232",
  sage: "#94A596",
  cream: "#FAF7F1",
  bone: "#F2EEE3",
  ink: "#0C2A20",
  paper: "#FFFFFF",
};

export const LOGOS = [
  { id: "circle", label: "Circle (green)", src: "/brand/logo-circle.png" },
  { id: "scalloped", label: "Scalloped (green)", src: "/brand/logo-scalloped.png" },
  { id: "white", label: "Circle (white)", src: "/brand/logo-white.png" },
];

export const defaultFlyer = {
  name: "Messy Pups - Host Site Pitch",
  logoId: "circle",
  customLogo: null, // base64 dataURL if user uploads

  brand: "MESSY PUPS",
  tagline: "Play. Wash. Repeat.",

  eyebrow: "Self-Service Dog Wash · Host Site Opportunity",
  headline: "Turn 2m² of unused space into passive monthly income.",
  subheadline:
    "We install, operate and maintain a premium self-service dog wash at your site. You provide the corner. We do everything else.",

  benefits: [
    {
      title: "Zero capex",
      body: "No equipment cost, no install fee, no maintenance bills. We fund and own the machine.",
    },
    {
      title: "Passive revenue",
      body: "Earn a 15% share of every wash — paid monthly. ~£1.50 per wash, all year round.",
    },
    {
      title: "Footfall magnet",
      body: "Dog owners visit weekly. Bring a loyal, high-spending customer base to your site.",
    },
  ],

  process: [
    { step: "01", title: "We install", body: "Plug-and-play unit, sited in 2m² indoor or sheltered outdoor space." },
    { step: "02", title: "Pups get washed", body: "Warm water, shampoo, conditioner, blow-dry — cashless payment." },
    { step: "03", title: "You get paid", body: "Monthly revenue share, transparent reporting, hands-off for your team." },
  ],

  stats: [
    { value: "£10", label: "Average wash price" },
    { value: "15%", label: "Your revenue share" },
    { value: "2m²", label: "Footprint needed" },
    { value: "0", label: "Hours of staff time" },
  ],

  requirements: {
    youProvide: [
      "2m² of accessible space",
      "Standard mains power (13A)",
      "Cold water + drainage",
      "A spot dog owners can easily reach",
    ],
    weProvide: [
      "Machine, install & branding",
      "Full maintenance & restocking",
      "Customer support & marketing",
      "Monthly payouts + reporting",
    ],
  },

  cta: "Let's talk about hosting a Messy Pups station at your site.",
  contact: {
    name: "Sarah Conacher",
    role: "Founder, Messy Pups",
    email: "sarah.conacher@gmail.com",
    phone: "",
    website: "",
    location: "Kingston upon Thames, UK",
  },

  footerNote: "Messy Pups · Kingston upon Thames · Play. Wash. Repeat.",
};
